import Oxxo from "../../assets/oxxopay.png";
import MercadoPago from "../../assets/mercado-pago.png";
import Mastercard from "../../assets/mastercard.png";
import Paypal from "../../assets/paypal.png";
import Visa from "../../assets/visa.png";
import Transferencia from "../../assets/transferencia.png";
import { Image, Row } from "react-bootstrap";

/**
 * Custom props for the payment image component
 */
interface Props {
    /**
     * The type of the payment method
     */
    type: string;
}

/**
 * Returns an image according to the type of a payment method
 */
export const PaymentImage = ({ type }: Props) => {
    /**
     * Reads the type of the payment method and returns an image component
     */
    const paymentImage = () => {
        if (!type) {
            return <></>
        };
        const payment = type.toLowerCase();
        if (payment.includes("oxxo")) {
            return <Image className="align-self-center" style={{ width: "330px", height: "81px" }} src={Oxxo} />
        }
        else if (payment.includes("mastercard") || payment.includes("visa") || payment.includes("crédito")) {
            return (
                <Row className="align-self-center">
                    <Image fluid src={`${Mastercard}`} style={{ width: "128px", height: "81px" }} />
                    <Image fluid src={Visa} style={{ width: "255px", height: "81px" }} />
                </Row>
            )
        }
        else if (payment.includes("paypal")) {
            return <Image className="align-self-center" style={{ width: "307px", height: "81px" }} src={Paypal} />
        }
        else if (payment.includes("mercado")) {
            return <Image className="align-self-center" style={{ width: "310px", height: "81px" }} src={MercadoPago} />
        }
        else if (payment.includes("transferencia")) {
            return <Image className="align-self-center" style={{ width: "139px", height: "139px" }} src={Transferencia} />
        }
        return <></>
    }

    return (
        paymentImage()
    )
}
